<ion-card class="report-card" [ngClass]="{'disabled': disabled}" (click)="onClick()">
  @if (ionIcon) {
    <ion-icon class="icon" [name]="ionIcon" aria-hidden="true" />
  } @else {
    <img [src]="icon" class="icon" alt="" />
  }
  <ion-label class="content">
    <h3 class="title">{{ title }}</h3>
    <p class="description">{{ description }}</p>
  </ion-label>
  @if (showChevron) {
    <ion-icon class="chevron" name="chevron-forward-outline" aria-hidden="true" />
  }
</ion-card>
